import { Content } from "./Content";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { pathOr } from "ramda";
import { useGlobal } from "reactn";
import { useLocation } from "react-router-dom";
import React from "react";
import styled from "styled-components";

const Layout = () => {
	const [config] = useGlobal("UIConfig");
	const [reservationsv3] = useGlobal("reservationsv3");

	const { hideHeader, hideFooter } = config;
	const oldIdReservation = pathOr(
		false,
		["oldIdReservation"],
		reservationsv3
	);

	return (
		<>
			{!hideHeader && !oldIdReservation && <Header />}
			<Content></Content>
			{!hideFooter && <Footer />}
		</>
	);
};

export const FixedSizeWrapper = styled.div`
	margin: 0 auto;
	max-width: 1240px;
	@media (min-width: 1240px) {
		max-width: 1400px;
	}
`;

const ContentMargin = styled.div`
	padding: 20px 0;
`;

const StyledBackground = styled.div`
	background: ${({ gradient }) => (gradient ? "rgb(19, 74, 172)" : "#fff")};
	background: ${({ gradient }) =>
		gradient
			? "radial-gradient(circle,rgba(19, 74, 172, 1) 0%,rgba(59, 28, 126, 1) 100%)"
			: "#fff"};
`;

export const BackgroundWrapper = ({ children }) => {
	const location = useLocation();
	const routesWithBackground = [
		"/signin",
		"/welcome",
		"/signup",
		"/logout",
		"/recover",
		"/password",
	];
	const routesIgnoreFixedSize = ["/offices", "/reserve", "/ticket"];
	const isGradient = routesWithBackground.includes(location.pathname);
	const canIgnoreFixedSize = routesIgnoreFixedSize.some((route) =>
		location.pathname.includes(route)
	);

	return (
		<StyledBackground gradient={isGradient}>
			{canIgnoreFixedSize ? (
				<>{children}</>
			) : (
				<ContentMargin>
					<FixedSizeWrapper>{children}</FixedSizeWrapper>
				</ContentMargin>
			)}
		</StyledBackground>
	);
};

export default Layout;
